import { gql } from '@apollo/client';

export const SORT_CATEGORIES_MUTATION = gql`
    mutation sortCategories($input: SortCategoriesInput!) {
        result: sortCategories(input: $input) {
            success
        }
    }
`;
